// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "span.icon-span[data-v-4d446720] {\n  margin-right: 1em;\n}\n.center[data-v-4d446720] {\n  text-align: center;\n  background-color: #f9f9f9;\n}\n", ""]);
// Exports
module.exports = exports;
